document.addEventListener('click', function(event) {
  var stickyButton = event.target.closest('.posture-sticky__button, .posture-offer-link');
  if (stickyButton) {
    var offer = document.querySelector('.lumin-product-block-qty-break');
    if (offer) {
      event.preventDefault();
      var top = window.scrollY + offer.getBoundingClientRect().top - 110;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      window.history.replaceState(null, '', '#posture-offers');
    }
    return;
  }

  var arrow = event.target.closest('[data-posture-scroll]');
  if (arrow) {
    var root = arrow.closest('[data-posture-carousel]');
    var track = root && root.querySelector('[data-posture-track]');
    if (track) {
      track.scrollBy({ left: (arrow.dataset.postureScroll === 'next' ? 1 : -1) * track.clientWidth * .86, behavior: 'smooth' });
    }
    return;
  }

  var expand = event.target.closest('[data-posture-expand]');
  if (expand) {
    var card = expand.closest('.posture-card');
    var open = card.classList.toggle('is-expanded');
    expand.textContent = open ? 'Read less' : 'Read more';
  }

  var dot = event.target.closest('[data-posture-dot]');
  if (dot) {
    var gallery = dot.closest('[data-posture-gallery]');
    var slides = gallery.querySelectorAll('.posture-gallery__slide');
    var target = slides[Number(dot.dataset.postureDot)];
    if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    gallery.querySelectorAll('.posture-dot').forEach(function(item) {
      item.classList.toggle('is-active', item === dot);
    });
  }
});

function postureSticky() {
  var offer = document.querySelector('.lumin-product-block-qty-break');
  if (offer) offer.id = 'posture-offers';
  document.querySelectorAll('[data-posture-sticky]').forEach(function(bar) {
    var threshold = Number(bar.dataset.threshold || 600);
    var offerVisible = false;
    if (offer) {
      var rect = offer.getBoundingClientRect();
      offerVisible = rect.top < window.innerHeight * .85 && rect.bottom > window.innerHeight * .15;
    }
    bar.classList.toggle('is-visible', window.scrollY > threshold && !offerVisible);
  });
}

window.addEventListener('scroll', postureSticky, { passive: true });
document.addEventListener('DOMContentLoaded', postureSticky);
window.addEventListener('load', postureSticky);
